<!-- Toggle FAB button -->
<button class="form-agent-toggle" (click)="panelVisible = !panelVisible" title="AI Form Assistant">
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 2a10 10 0 1 0 10 10"/>
    <path d="M12 8v4l3 3"/>
    <circle cx="18" cy="5" r="3"/>
  </svg>
  <span *ngIf="!panelVisible" class="toggle-label">AI Assistant</span>
  <span *ngIf="state.loading" class="toggle-dot"></span>
</button>

<!-- Panel -->
<div class="form-agent-panel" *ngIf="panelVisible">
  <div class="fap-header">
    <div class="fap-avatar">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 8v4"/>
        <path d="M12 16h.01"/>
      </svg>
    </div>
    <span class="fap-title">Form Assistant</span>
    <button class="fap-close" (click)="panelVisible = false">&times;</button>
  </div>

  <div class="fap-body">
    <!-- Idle state -->
    <div class="fap-idle" *ngIf="!state.loading && !state.hint">
      <p>Start filling the form &mdash; I'll validate each field as you go.</p>
      <ul>
        <li>Tax ID format (EIN: XX-XXXXXXX)</li>
        <li>Email validity &amp; domain type</li>
        <li>Name and date rules</li>
        <li>Cross-field matching</li>
      </ul>
    </div>

    <!-- Loading -->
    <div class="fap-loading" *ngIf="state.loading">
      <div class="fap-field-label">Checking <strong>{{ state.field }}</strong>&hellip;</div>
      <div class="fap-dots"><span></span><span></span><span></span></div>
    </div>

    <!-- Hint result -->
    <div class="fap-hint" *ngIf="!state.loading && state.hint" [ngClass]="'fap-hint--' + state.severity">
      <div class="fap-hint-field">{{ state.field }}</div>
      <div class="fap-hint-text">{{ state.hint }}</div>
      <button class="fap-hint-clear" (click)="clearHint()">&times;</button>
    </div>
  </div>
</div>
